import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "frm-head" }
const _hoisted_2 = { class: "frm-icon" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "frm-row" }
const _hoisted_5 = {
  key: 0,
  class: "frm-hint"
}
const _hoisted_6 = {
  key: 1,
  class: "frm-hint"
}
const _hoisted_7 = {
  key: 0,
  class: "frm-summary"
}
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = { value: null }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["onUpdate:modelValue", "min", "max"]
const _hoisted_14 = {
  key: 1,
  class: "frm-hint frm-none"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "frm-row" }
const _hoisted_17 = {
  key: 2,
  class: "frm-error",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["frm", { 'frm-busy': _ctx.busy }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_svg_icon, { icon: "twousers" })
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "frm-head-text" }, [
        _createElementVNode("div", { class: "frm-title" }, "The Forge · milestones"),
        _createElementVNode("div", { class: "frm-sub" }, "Drafts the steps this rock still needs, dated through the quarter. Its milestones stay; nothing is saved until you save the rock.")
      ], -1))
    ]),
    (_ctx.phase == 'input')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.direction) = $event)),
            rows: "2",
            maxlength: "2000",
            disabled: _ctx.busy,
            class: "frm-text",
            placeholder: "Anything the Forge should know? e.g. the first step is already under way, or keep it to three steps"
          }, null, 8, _hoisted_3), [
            [_vModelText, _ctx.direction]
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["btn frm-btn", _ctx.canDraft ? '' : 'disable-button']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.draft(false)))
            }, _toDisplayString(_ctx.busy ? 'Drafting…' : (_ctx.form.Milestones.length ? 'Draft the missing milestones' : 'Draft milestones')), 3),
            (!_ctx.nameOk)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Name the rock first."))
              : (_ctx.added)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Added " + _toDisplayString(_ctx.added) + ". Save the rock to keep " + _toDisplayString(_ctx.added == 1 ? 'it' : 'them') + ".", 1))
                : _createCommentVNode("", true)
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.summary)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.summary), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (r, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: _normalizeClass(["frm-ms", r.keep ? '' : 'frm-ms-off'])
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": ($event: any) => ((r.keep) = $event),
                "aria-label": "Add this milestone"
              }, null, 8, _hoisted_8), [
                [_vModelCheckbox, r.keep]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": ($event: any) => ((r.text) = $event),
                class: "frm-ms-text",
                "aria-label": "Milestone"
              }, null, 8, _hoisted_9), [
                [_vModelText, r.text]
              ]),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((r.ownerEmployeeID) = $event),
                class: "frm-ms-own",
                "aria-label": "Milestone owner"
              }, [
                _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.form.OwnerEmployeeID ? 'Rock owner' : 'No owner'), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (e) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: e.ID,
                    value: e.ID
                  }, _toDisplayString(e.Name), 9, _hoisted_12))
                }), 128))
              ], 8, _hoisted_10), [
                [_vModelSelect, r.ownerEmployeeID]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": ($event: any) => ((r.dueDate) = $event),
                min: _ctx.earliest,
                max: _ctx.bounds.end,
                class: "frm-ms-date",
                "aria-label": "Due date"
              }, null, 8, _hoisted_13), [
                [_vModelText, r.dueDate]
              ])
            ], 2))
          }), 128)),
          (!_ctx.rows.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Nothing new suggested; it already looks planned. Say what you want below and draft again."))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.direction) = $event)),
            rows: "2",
            maxlength: "2000",
            disabled: _ctx.busy,
            class: "frm-text",
            placeholder: "Want anything changed? e.g. shorter steps, or finish by mid-November"
          }, null, 8, _hoisted_15), [
            [_vModelText, _ctx.direction]
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: _normalizeClass(["btn frm-btn", _ctx.keptCount && !_ctx.busy ? '' : 'disable-button']),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.add()))
            }, "Add " + _toDisplayString(_ctx.keptCount) + " milestone" + _toDisplayString(_ctx.keptCount == 1 ? '' : 's'), 3),
            _createElementVNode("div", {
              class: _normalizeClass(["btn-light frm-btn", _ctx.busy ? 'disable-button' : '']),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.draft(true)))
            }, _toDisplayString(_ctx.busy ? 'Drafting…' : 'Draft again'), 3),
            _createElementVNode("a", {
              class: "frm-link",
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.reset()), ["prevent"]))
            }, "Cancel")
          ])
        ], 64)),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 2))
}